var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CloseIcon from "@mui/icons-material/Close";
import { Drawer, Box, Typography, IconButton } from "@mui/material";
var UniversalDrawer = function (_a) {
    var open = _a.open, onClose = _a.onClose, _b = _a.anchor, anchor = _b === void 0 ? "right" : _b, title = _a.title, drawerSx = _a.drawerSx, headerSx = _a.headerSx, contentSx = _a.contentSx, _c = _a.width, width = _c === void 0 ? 400 : _c, children = _a.children, paperSx = _a.paperSx, rootSx = _a.rootSx;
    return (_jsx(Drawer, { anchor: anchor, open: open, onClose: onClose, transitionDuration: 300, sx: rootSx, PaperProps: {
            sx: __assign({ borderTopLeftRadius: 25, borderTopRightRadius: 25 }, paperSx),
        }, children: _jsxs(Box, { sx: __assign({ width: anchor === "left" || anchor === "right" ? width : "100%", height: "100%", display: "flex", flexDirection: "column" }, drawerSx), children: [title && (_jsxs(Box, { sx: __assign({ display: "flex", alignItems: "center", justifyContent: "space-between", p: "16px 16px 0 16px" }, headerSx), children: [_jsx(Typography, { variant: "h6", sx: { fontFamily: "'Kodchasan', 'Rubik', sans-serif" }, children: title }), _jsx(IconButton, { onClick: onClose, children: _jsx(CloseIcon, { sx: { color: "#fff" } }) })] })), _jsx(Box, { sx: __assign({ flex: 1, overflow: "auto", p: 2 }, contentSx), children: children })] }) }));
};
export default UniversalDrawer;
